import PropTypes from 'prop-types'
import {flowRight as compose} from 'lodash'
import React, {Component} from 'react'
import {frontends} from '@bdswiss/common-enums'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import {getPlatform} from '../../../../common/utils'
import {withCreateDeposit, PaymentActionButton} from './helpers'
import DescriptionPaymentMethod from './DescriptionPaymentMethod'

class GenericRedirectProvider extends Component {

  state = {gettingUrl: false}

  getUrl() {
    const {providerProperties: {provider, paymentKey}, account, amount, onError, useVirtualPaymentPage, bonusAmount, bonusTerms} = this.props

    this.setState({gettingUrl: true})

    const variables = {
      accountId: account.id,
      amount,
      vendor: provider,
      frontend: frontends.web2.value,
      args: JSON.stringify({
        platform: getPlatform(),
        paymentKey,
        useVirtualPaymentPage,
        bonusAmount,
        bonusTerms,
      }),
    }

    this.props.createDepositRequest({variables})
      .then(({data: {newDeposit}}) => {
        const {payment: {url}} = newDeposit
        window.location = url
      })
      .catch((e) => {
        this.setState({gettingUrl: false})
        onError && onError(e)
      })
  }

  render() {
    const {providerProperties: {provider}, disablePayment} = this.props
    const {gettingUrl} = this.state
    return (
      <React.Fragment>
        <DescriptionPaymentMethod provider={provider}/>
        <PaymentActionButton
          loading={gettingUrl}
          onClick={() =>  this.getUrl()}
          disable={disablePayment}
        />
      </React.Fragment>
    )
  }
}

GenericRedirectProvider.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  amount: PropTypes.number.isRequired,
  providerProperties: PropTypes.shape({
    name: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
    paymentKey: PropTypes.string,
  }).isRequired,
  onError: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
}

export default compose(
  withMobileDialog(),
  withCreateDeposit
)(GenericRedirectProvider)
